var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 77",
    width: 84,
    height: 77,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 88,
    height: 61,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAA9CAMAAAAecl7vAAAAAXNSR0IB2cksfwAAADlQTFRF////98fJ74+U6Fhf/OfO+c+c9bdr4CAp8p469sDA+MqW40Ir7YEz52Qt4jEq5VMs75A36nMw74qNo4qBfQAAAU9JREFUeJztl9sSgjAMRJsC4oz//606AkW5aZtuaAB5snkjwnFnm7QpmZOCMjiDM/h/wETTC33fe9nyk213ga2pvKfWzeyq8LLOSWwRTFSxTNtx7BpaAluOHZPkQLZrNoCLEmVLgurcUw0WuNbg5UJkCBa5Rk9GYOivqaeqwOTYZwCmC/rULFm4VDEZgLER16UghK54JMFYcP1tPZ3kGJwQrF2/CCw47IEFyW34fxF4tSSmKLifYzAvIvBKDS+hqrjfgVldROAafuRbbMp7Bp8ADhYPg1mHKOs4AOM63gdWNEiq8xKb5hD7WjrthcpiNdjzQuUE2ugTdaETjMBY8sdlneANh+ksWbVnCuDTjv/zBpaNIxYc3jYNhbfH4aHw/YPlohs3uGFZthPOk5XBO0Q3s9gQ3Qn9nbwqzBB+VZhuCtKuoQAfiAzO4AzOYE28AITkiT4feItVAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: -2,
    y: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.a150bf4df7d99f3180ad476c0b594090.svg";
export { ForwardRef as ReactComponent };